import { Shared } from 'modules'
import { PATHS, TValueOfPromise } from 'fractals'
// eslint-disable-next-line import/no-cycle
import { Header } from '~widgets/header/components/header'
import {
  getFacultiesData,
  getMissionData,
  getStoriesData
} from '@/modules/home-page'
import {
  getJournalsData,
  getFacultiesData as getFacultiesFromJournalsData,
  getTagsData,
  getAllJournals
} from '@/modules/journals-page/widgets/Journals'
import { FaqSection } from '~widgets/faq/components/faq-section'
import { Footer } from '~widgets/footer/components/footer'
import { Hero } from './hero-section'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { CategoriesSection } from './categories-section'
import { LeadForm1Section, LeadForm2Section } from './lead-form-section'
import { GraduationDocsSection } from './graduation-docs-section'
import { AboutMitmSection } from './about-mitm-section'
import { OurAdvantagesSection } from './out-advantages-section'
import { JournalSection } from './journal-section'
import { WhyUsSection } from './why-us-section'
import { OurMissionSection } from './our-mission-section'
import { TestSection } from './test-section'
import { PopularProgramsSection } from './popular-programs-section'
import { AdvantagesSection } from './advantages-section'
import { ProgramsSection } from './programs-section'
import { StoriesSection } from './stories-section'
import { ResultsSection } from './results-section'
import { EdForAllSection } from './ed-for-all-section'
import { getReviews } from '~shared/api/reviews/get-reviews'
import { NextSeo } from 'next-seo'
import Head from 'next/head'

export type THomePageProps = {
  stories: TValueOfPromise<typeof getStoriesData>
  tags: TValueOfPromise<typeof getTagsData>
  mission: TValueOfPromise<typeof getMissionData>
  journals: TValueOfPromise<typeof getJournalsData>
  allJournals: TValueOfPromise<typeof getAllJournals>
  faculties: TValueOfPromise<typeof getFacultiesData>
  whyUs: TValueOfPromise<typeof Shared.getWhyUsData>
  videos: TValueOfPromise<typeof Shared.getVideoData>
  images: TValueOfPromise<typeof Shared.getProgramImagesData>
  footer: TValueOfPromise<typeof Shared.getFooterData>
  popularPrograms: TValueOfPromise<typeof getPopularPrograms>
  diplomas: TValueOfPromise<typeof Shared.getDiplomasData>
  questions: TValueOfPromise<typeof Shared.getFAQData>
  categories: TValueOfPromise<typeof getCategoriesData>
  facultiesFromJournals: TValueOfPromise<typeof getFacultiesFromJournalsData>
  reviews: TValueOfPromise<typeof getReviews>
}

export const HomePage = ({
  stories,
  faculties,
  mission,
  diplomas,
  whyUs,
  questions,
  categories,
  videos,
  journals,
  allJournals,
  facultiesFromJournals,
  tags,
  images,
  footer,
  popularPrograms,
  reviews
}: THomePageProps) => {
  // console.log('diplomas', diplomas.value)
  // console.log('mission', mission)
  // console.log('whyUs', whyUs)
  // console.log('questions', questions) -vercel
  // console.log('images', images)
  // console.log('facultiesFromJournals', facultiesFromJournals)

  const seoParams = {
    title:
      'Онлайн образование от MITM.institute | Обучение современным профессиям',
    desc: 'Самый инновационный ВУЗ страны - MITM.institute предлагает дистанционные онлайн-курсы по востребованным направлениям и специальностям. Удобный формат обучения со скидкой 30% Государственная аккредитация! Актуальные подходы к образованию вместе с экспертами-практиками',
    canonical: `${PATHS.front.home.index}`
  }
  return (
    <>
      <Head>
        <title itemProp='headline'>{seoParams.title}</title>
        <meta
          itemProp='description'
          name='description'
          content={seoParams.desc}
        />
      </Head>
      <NextSeo
        canonical={seoParams.canonical}
        openGraph={{
          url: seoParams.canonical,
          title: seoParams.title,
          description: seoParams.desc,
          images: [
            {
              url: `${PATHS.front.root.index}${PATHS.front.public.assets.imgs.icons.mitmLogo512.index}`,
              width: 512,
              height: 512,
              alt: 'Московский Институт Технологий и Управления',
              type: 'image/png'
            }
          ],
          site_name: 'Московский Институт Технологий и Управления'
        }}
      />
      <div className='box-border leading-[1.2]'>
        <Header
          categories={categories.value}
          popularPrograms={popularPrograms.value}
        />
        <Hero stories={stories.value} categories={categories.value} />
        <AdvantagesSection />
        {/* <TestSection /> */}
        <CategoriesSection
          categories={categories.value}
          className='mt-section-indent'
        />
        <ProgramsSection
          categories={categories.value}
          className='mt-section-indent'
        />
        <PopularProgramsSection
          popularPrograms={popularPrograms.value}
          className='mt-section-indent'
        />
        {/* <StoriesSection
          videos={videos.value}
          reviews={reviews.value}
          className='mt-section-indent'
        /> */}
        <ResultsSection className='mt-section-indent' />
        <AboutMitmSection className='mt-section-indent' />
        <OurMissionSection className='mt-section-indent' />
        <EdForAllSection className='mt-section-indent' />
        <OurAdvantagesSection className='mt-section-indent' />
        <GraduationDocsSection
          diplomas={diplomas.value}
          className='mt-section-indent'
        />
        <WhyUsSection className='mt-section-indent' />
        <LeadForm1Section className='mt-section-indent' />
        <JournalSection
          journals={journals.value}
          allJournals={allJournals.value}
          facultiesFromJournals={facultiesFromJournals.value}
          tags={tags.value}
          className='mt-section-indent'
        />
        <FaqSection className='mt-section-indent' />
        <LeadForm2Section className='mt-section-indent' />
        <Footer data={footer?.value} className='mt-section-indent' />
      </div>
    </>
  )
}
